import script from "./OrderInvoicesRow.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderInvoicesRow.vue?vue&type=script&setup=true&lang=js"

import "./OrderInvoicesRow.vue?vue&type=style&index=0&id=13af4fbe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13af4fbe"]])

export default __exports__